import styled from "@emotion/styled";
import {PrimaryButton} from "components/Common";

export const Button = styled(PrimaryButton)`
	max-width: 188px;
	margin-bottom: 20px;
`;
